import { BondTradingPane } from '../types'
import { UPDATE_BOND_TRADING_PANE, SET_BOND_AMOUNT, CHANGE_BOND_BUY_MODE } from '../constants'
import {
  UpdateBondTradingPane,
  SetBondAmount,
  ChangeBondBuyModeAction,
  ShowBondDetailDialog,
  HideBondDetailDialog,
} from '../actions/bondActions'
import * as constants from '../constants'
import { BondBuyMode } from '@bdswiss/mt4-connector'

const initialState: BondTradingPane = {
  amount: 0,
  amountInitial: 0,
  tradeOperationEnabled: true,
  rate: 1,
  bondBuyMode: BondBuyMode.BOND_BUY_MODE_CASH,
  showBondDetailDialog: false,
}

type TrabdingPaneAction =
  | UpdateBondTradingPane
  | SetBondAmount
  | ChangeBondBuyModeAction
  | ShowBondDetailDialog
  | HideBondDetailDialog

export function bondsTradingPane(
  state = initialState,
  action: TrabdingPaneAction
): BondTradingPane {
  switch (action.type) {
    case UPDATE_BOND_TRADING_PANE:
      return { ...state, ...action.pane }
    case SET_BOND_AMOUNT:
      return { ...state, amount: action.bondAmount }
    case CHANGE_BOND_BUY_MODE:
      return { ...state, bondBuyMode: action.buyMode }
    case constants.SHOW_BOND_DETAIL_DIALOG:
      return { ...state, showBondDetailDialog: true }
    case constants.HIDE_BOND_DETAIL_DIALOG:
      return { ...state, showBondDetailDialog: false }

    default:
      return state
  }
}
